<template functional>
    <div :style="{width: props.widthRem + 'rem', height: props.widthRem + 'rem'}">
        <div class="spinner-scaleout"></div>
    </div>
</template>

<script>

export default {
    functional: true,
    name: 'SpinnerScaleout',
    props: {
        widthRem: {
            type: Number,
            default: 1,
        }
    },
}
</script>

<style>
.spinner-scaleout {
  width: 100%;
  height: 100%;
  margin: 0;
  background-color: #333;

  border-radius: 100%;  
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}
</style>